/* Yummy Gummy — PDP sticky add-to-cart bar.
   See sections/pdp-sticky-atc.liquid's own header comment for the full
   design rationale (ID-prefix cross-section lookup, two-way sync via
   Dawn's real variant pipeline, form-submit reuse). Safe & idempotent. */
(function () {
  'use strict';

  function findMain() {
    return {
      root: document.querySelector('[id^="MainProduct-"]'),
      form: document.querySelector('[id^="product-form-"]'),
      submitBtn: document.querySelector('[id^="ProductSubmitButton-"]'),
      variantSelects: document.querySelector('[id^="MainProduct-"] variant-selects'),
      priceEl: document.querySelector('[id^="price-"] .pdp-mp__price')
    };
  }

  /* --- Visibility: hidden until the main ATC scrolls out of view, and
     hidden again once the footer comes into view so it never overlaps
     it. Both are plain "is this element on screen" checks, combined. --- */
  function initVisibility(bar, main) {
    if (!main.submitBtn) return;

    var mainAtcPastViewport = false;
    var footerVisible = false;

    function sync() {
      var shouldShow = mainAtcPastViewport && !footerVisible;
      bar.classList.toggle('is-visible', shouldShow);
      bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    }

    new IntersectionObserver(function (entries) {
      var entry = entries[0];
      mainAtcPastViewport = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      sync();
    }).observe(main.submitBtn);

    /* This theme's actual rendered footer is the rebuilt .yg-gf section
       (see assets/yg-gruns-footer.css), not Dawn's stock <footer
       class="footer"> — confirmed live, not assumed from source, after
       that assumption first version of this file made produced a real
       bug (bar stayed visible over the footer). Falls back to a plain
       <footer> tag if that class is ever absent, rather than silently
       never hiding. */
    var footer = document.querySelector('footer.yg-gf') || document.querySelector('footer');
    if (footer) {
      new IntersectionObserver(function (entries) {
        footerVisible = entries[0].isIntersecting;
        sync();
      }).observe(footer);
    }
  }

  /* --- Sticky → main: drive the MAIN variant-selects' real controls,
     then let Dawn's own VariantSelects handle the fetch/update/publish
     cycle exactly as a direct click would. --- */
  function initVariantSelect(bar, main) {
    var select = bar.querySelector('[data-pdp-satc-variant-select]');
    var variantsJson = bar.querySelector('[data-pdp-satc-variants]');
    if (!select || !variantsJson || !main.variantSelects) return;

    var variants;
    try {
      variants = JSON.parse(variantsJson.textContent);
    } catch (e) {
      return;
    }

    select.addEventListener('change', function () {
      var target = variants.filter(function (v) { return String(v.id) === select.value; })[0];
      if (!target) return;

      var lastControl = null;
      [1, 2, 3].forEach(function (position) {
        var value = target['option' + position];
        if (value == null) return;

        var radio = main.variantSelects.querySelector(
          'input[type="radio"][name$="-' + position + '"][value="' + CSS.escape(value) + '"]'
        );
        if (radio) {
          radio.checked = true;
          lastControl = radio;
          return;
        }
        var opt = main.variantSelects.querySelector('select option[value="' + CSS.escape(value) + '"]');
        if (opt && opt.closest('select')) {
          opt.closest('select').value = value;
          lastControl = opt.closest('select');
        }
      });

      if (lastControl) {
        lastControl.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    /* Main → sticky: keep this bar's own select in sync too, so it never
       shows a stale selection if the shopper uses the main picker
       instead. */
    if (window.subscribe && window.PUB_SUB_EVENTS) {
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event && event.data && event.data.variant;
        if (variant) select.value = variant.id;
      });
    }
  }

  /* --- Custom dropdown chrome over the (visually-hidden) real <select>.
     Mirrors the buy box's subscribe frequency dropdown: trigger toggles a
     white menu; picking an option writes the value onto the real <select>
     and dispatches a `change`, so initVariantSelect's existing handler runs
     the normal Dawn variant pipeline. The browser's own themed option popup
     is never used. Progressive: absent this wiring, the real <select> still
     works. --- */
  function initVariantDropdown(bar) {
    var wrap = bar.querySelector('[data-pdp-satc-variant]');
    if (!wrap) return;
    var select = wrap.querySelector('[data-pdp-satc-variant-select]');
    var trigger = wrap.querySelector('[data-pdp-satc-variant-trigger]');
    var label = wrap.querySelector('[data-pdp-satc-variant-label]');
    var menu = wrap.querySelector('[data-pdp-satc-variant-menu]');
    if (!select || !trigger || !menu) return;

    function open() {
      menu.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
    }
    function close() {
      menu.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
    }

    /* Reflect the current <select> value onto the trigger label + which menu
       row is marked selected. Called on init and after any change (main
       picker, this menu, or a variant switch). */
    function syncFromSelect() {
      var opt = select.options[select.selectedIndex];
      if (opt && label) label.textContent = (opt.textContent || '').trim();
      Array.prototype.forEach.call(menu.querySelectorAll('[role="option"]'), function (li) {
        var btn = li.querySelector('[data-pdp-satc-variant-option]');
        li.setAttribute('aria-selected', btn && btn.getAttribute('data-value') === select.value ? 'true' : 'false');
      });
    }

    trigger.addEventListener('click', function () {
      if (trigger.getAttribute('aria-expanded') === 'true') close();
      else open();
    });

    menu.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-pdp-satc-variant-option]');
      if (!btn || btn.disabled) return;
      var value = btn.getAttribute('data-value');
      if (value && select.value !== value) {
        select.value = value;
        /* Drives initVariantSelect's own change handler → Dawn pipeline. */
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      syncFromSelect();
      close();
    });

    document.addEventListener('click', function (event) {
      if (!wrap.contains(event.target)) close();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
    });

    /* Keep the custom UI honest when the MAIN picker changes the variant. */
    if (window.subscribe && window.PUB_SUB_EVENTS) {
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, function () {
        syncFromSelect();
      });
    }

    syncFromSelect();
  }

  /* --- Main → sticky: mirror price (copied from the main section's own
     freshly-formatted text — never reformatted here) + thumbnail (from
     the raw variant JSON, since that's already reliably available). --- */
  function initMirroring(bar, main) {
    if (!window.subscribe || !window.PUB_SUB_EVENTS) return;

    var priceEl = bar.querySelector('[data-pdp-satc-price]');
    var thumbImg = bar.querySelector('[data-pdp-satc-thumb]');

    window.subscribe(window.PUB_SUB_EVENTS.variantChange, function (event) {
      var variant = event && event.data && event.data.variant;

      if (priceEl) {
        var mainPriceEl = document.querySelector('[id^="price-"] .pdp-mp__price');
        if (mainPriceEl) priceEl.textContent = mainPriceEl.textContent;
      }

      if (thumbImg && variant && variant.featured_media && variant.featured_media.preview_image) {
        var src = variant.featured_media.preview_image.src;
        var sep = src.indexOf('?') > -1 ? '&' : '?';
        thumbImg.src = src + sep + 'width=120';
      }

      var atc = bar.querySelector('[data-pdp-satc-atc]');
      if (atc) atc.disabled = !variant || variant.available === false;
    });
  }

  /* --- Add to cart: submit the SAME real form the main section uses. --- */
  function initAtc(bar, main) {
    var btn = bar.querySelector('[data-pdp-satc-atc]');
    if (!btn) return;

    btn.addEventListener('click', function () {
      var form = document.querySelector('[id^="product-form-"]');
      if (!form) return;
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
    });
  }

  function init() {
    var bar = document.querySelector('[data-pdp-satc]');
    if (!bar || bar.__pdpBound) return;
    bar.__pdpBound = true;

    var main = findMain();
    if (!main.root) return;

    try { initVisibility(bar, main); } catch (e) {}
    try { initVariantSelect(bar, main); } catch (e) {}
    try { initVariantDropdown(bar); } catch (e) {}
    try { initMirroring(bar, main); } catch (e) {}
    try { initAtc(bar, main); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
